/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ats_Tip_Add_EmailInputs */

const en_ats_tip_add_email = /** @type {(inputs: Ats_Tip_Add_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add an email address — required by most ATS`)
};

const de_ats_tip_add_email = /** @type {(inputs: Ats_Tip_Add_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Füge eine E-Mail-Adresse hinzu — von den meisten ATS verlangt`)
};

const fr_ats_tip_add_email = /** @type {(inputs: Ats_Tip_Add_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajoutez une adresse e-mail — requise par la plupart des ATS`)
};

const es_ats_tip_add_email = /** @type {(inputs: Ats_Tip_Add_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añade una dirección de correo electrónico — requerida por la mayoría de los ATS`)
};

const it_ats_tip_add_email = /** @type {(inputs: Ats_Tip_Add_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi un indirizzo e-mail — richiesto dalla maggior parte degli ATS`)
};

const nl_ats_tip_add_email = /** @type {(inputs: Ats_Tip_Add_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voeg een e-mailadres toe — vereist door de meeste ATS`)
};

const pl_ats_tip_add_email = /** @type {(inputs: Ats_Tip_Add_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dodaj adres e-mail — wymagany przez większość systemów ATS`)
};

const fi_ats_tip_add_email = /** @type {(inputs: Ats_Tip_Add_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lisää sähköpostiosoite — useimmat ATS-järjestelmät vaativat sen`)
};

const da_ats_tip_add_email = /** @type {(inputs: Ats_Tip_Add_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilføj en e-mailadresse — kræves af de fleste ATS`)
};

const sv_ats_tip_add_email = /** @type {(inputs: Ats_Tip_Add_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lägg till en e-postadress — krävs av de flesta ATS`)
};

/**
* | output |
* | --- |
* | "Add an email address — required by most ATS" |
*
* @param {Ats_Tip_Add_EmailInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const ats_tip_add_email = /** @type {((inputs?: Ats_Tip_Add_EmailInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ats_Tip_Add_EmailInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ats_tip_add_email(inputs)
	if (locale === "fr") return fr_ats_tip_add_email(inputs)
	if (locale === "es") return es_ats_tip_add_email(inputs)
	if (locale === "it") return it_ats_tip_add_email(inputs)
	if (locale === "nl") return nl_ats_tip_add_email(inputs)
	if (locale === "pl") return pl_ats_tip_add_email(inputs)
	if (locale === "fi") return fi_ats_tip_add_email(inputs)
	if (locale === "da") return da_ats_tip_add_email(inputs)
	if (locale === "sv") return sv_ats_tip_add_email(inputs)
	return en_ats_tip_add_email(inputs)
});